module.exports = __webpack_public_path__ + "static/media/r306.cd62ae3e.jpg";